import { useAuthenticator } from '@aws-amplify/ui-react'
import clsx from 'clsx'
import React from 'react'
import ArrowRightEndOnRectangle from '../../assets/arrow-right-end-on-rectangle.svg?react'
import ArrowRightStartOnRectangle from '../../assets/arrow-right-start-on-rectangle.svg?react'
import UserArrow from '../../assets/user-arrow.svg?react'
import { useGlobalContext } from '../../providers/global-provider/use-global-context'
import { logOutAction, requireAuthenticatorAction } from '../../reducers/app-reducer/actions'
import { deleteCookie } from '../../utils'
import { IconButton } from '../icon-button'
import { translate } from '../internationalization'
import s from './login-signup.module.css'

type Props = {
  className?: string
}
export const LoginSignup: React.FC<Props> = ({ className }) => {
  const { user, signOut } = useAuthenticator((context) => [context.user, context.signOut])
  const { dispatch } = useGlobalContext()

  const onSignIn = () => {
    if (user) return
    dispatch!(requireAuthenticatorAction())
  }

  const onSignOut = () => {
    // Delete all cookies regardless of user state
    deleteCookie('idToken')
    deleteCookie('accessToken')
    deleteCookie('docu.idToken')

    if (!user) return

    signOut()
    localStorage.clear()
    dispatch!(logOutAction())

    // There is no way to reset relay store exept reload, see https://github.com/facebook/relay/issues/233
    // Screen flickering does not look pretty for the user but otherwise relay-runtime reports various issues related to rutime swap of query variables
    window.location.reload()
    window.location.replace('/')
  }

  const onSignUp = () => {
    if (user) return;
    
    dispatch!(requireAuthenticatorAction('signUp'))
  }

  return <div className={clsx(s.container, className)}>
    {!user && <IconButton cta={true} icon={UserArrow} onClick={onSignUp}>{translate('Sing up')}</IconButton>}
    {!user && <IconButton icon={ArrowRightEndOnRectangle} className={s.signin} onClick={onSignIn}>{translate('Sign in')}</IconButton>}
    {user && <IconButton icon={ArrowRightStartOnRectangle} onClick={onSignOut} />}
  </div>
}
